<template>
    <svg width="23" height="7" viewBox="0 0 23 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cy="2.5" cx="19.5" r="2.5"/>
        <circle cy="2.5" cx="11.5" r="2.5"/>
        <circle cy="2.5" cx="3.5" r="2.5"/>
    </svg>
</template>
